import { render, staticRenderFns } from "./CreatorTagNameplate.vue?vue&type=template&id=62b15296&"
import script from "./CreatorTagNameplate.vue?vue&type=script&lang=js&"
export * from "./CreatorTagNameplate.vue?vue&type=script&lang=js&"
import style0 from "./CreatorTagNameplate.vue?vue&type=style&index=0&id=62b15296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports